import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { Button } from '@material-ui/core';

import { Loaders } from 'components';
import { UserProfileInput } from 'api';

const Submit: FC = () => {
  const { t } = useTranslation();
  const { isSubmitting, isValid } = useFormikContext<UserProfileInput>();

  return (
    <Button disabled={!isValid} color="primary" size="large" type="submit" variant="contained">
      {isSubmitting ? <Loaders.Standard color="white" height={26} /> : t('components:saveChanges')}
    </Button>
  );
};

export default Submit;
